import { render, staticRenderFns } from "./MaintCollapsibleBanner.vue?vue&type=template&id=868bccfc&scoped=true"
import script from "./MaintCollapsibleBanner.vue?vue&type=script&lang=js"
export * from "./MaintCollapsibleBanner.vue?vue&type=script&lang=js"
import style0 from "./MaintCollapsibleBanner.vue?vue&type=style&index=0&id=868bccfc&prod&scoped=true&lang=css"
import style1 from "./MaintCollapsibleBanner.vue?vue&type=style&index=1&id=868bccfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868bccfc",
  null
  
)

export default component.exports